import { IDailyForecastData } from "@/types/daily-forecast-type";

export const findDailyForecastById = (
	stationId: string,
	dailyData: IDailyForecastData[],
	numberOfDays = 10,
): IDailyForecastData[] => {
	return Array.from({ length: numberOfDays }, (_, idx) => {
		const date = new Date();
		date.setHours(0, 0, 0, 0);
		date.setDate(date.getDate() + idx);

		const forecast = dailyData.find((item) => {
			const itemDate = new Date(item.date);
			itemDate.setHours(0, 0, 0, 0);

			return (
				item.station_id === stationId && itemDate.getTime() === date.getTime()
			);
		});

		return (
			forecast ?? {
				station_id: stationId,
				date,
				temperature_max: undefined,
				temperature_min: undefined,
				ww: undefined,
			}
		);
	});
};
